import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import { AWS_PROFILE_IMAGES_URL } from "constants";
import { dateFormatted } from "modules/functions";
import { Tooltip } from "react-tooltip";

import ButtonRoundIcon from "components/buttons/ButtonRoundIcon";

import coinsIcon from "assets/img/icons/coins-icon.svg";
import blockIcon from "assets/img/icons/icons8-unavailable.svg";
import profilePictureIcon from "assets/img/icons/icons8-profile-picture.svg";
import messageIcon from "assets/img/icons/icons8-new-message.svg";
import messageWhiteIcon from "assets/img/icons/icons8-new-message-white.svg";
import leftIcon from "assets/img/icons/left-arrow.svg";
import rightIcon from "assets/img/icons/right-arrow.svg";
import leftWhiteIcon from "assets/img/icons/left-arrow-white.svg";
import rightWhiteIcon from "assets/img/icons/right-arrow-white.svg";
import bronzeCheckmarkIcon from "assets/img/icons/checkmark-bronze.svg";
import silverCheckmarkIcon from "assets/img/icons/checkmark-silver.svg";
import goldCheckmarkIcon from "assets/img/icons/checkmark-gold.svg";

const ReferralListBox = styled.div`
  width: 100%;
  min-height: 280px;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
`;

const TableWrap = styled.div`
  width: 100%;
  padding-bottom: 5px;
  margin-bottom: -5px;

  overflow-x: auto;
`;

const ListTable = styled.table`
  width: 100%;
  min-width: 485px;
  max-width: 700px;
`;

const TableHead = styled.thead``;

const Label = styled.th`
  padding-bottom: 12px;

  font-size: 18px;
  font-weight: 400;
  text-align: left;
`;

const TableBody = styled.tbody``;

const Cell = styled.td``;

const AvatarNameBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const AvatarIcon = styled.div`
  margin: 4px 0;

  width: 32px;
  min-width: 32px;
  height: 32px;
  background-image: ${(props) => `url(${props.image})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;

  border-radius: 16px;

  overflow: hidden;
`;

const Name = styled.div``;

const Badge = styled.div`
  height: 22px;
  width: 50px;

  font-size: 13px;

  border-radius: 11px;
  background: ${(props) =>
    props.green ? css.POSITIVE_GREEN : css.NEGATIVE_RED};

  display: flex;
  justify-content: center;
  align-items: center;
`;

const RewardBox = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
`;

const CoinsIcon = styled.div`
  width: 20px;
  min-width: 20px;
  height: 20px;
`;

const Reward = styled.div``;

const Pagination = styled.div`
  width: 100%;
  margin-top: ${css.VERTICAL_BOX_MARGIN_MEDIUM};

  display: flex;
  justify-content: center;
  gap: ${css.BUTTONS_GAP_SMALL};
`;

const NoResults = styled.div`
  width: 100%;
  margin-top: 75px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const NoResultsIcon = styled.div`
  width: 32px;
  min-width: 32px;
  height: 32px;
`;

const NoResultsText = styled.div``;

const NewMessageIcon = styled.div`
  width: 14px;
  height: 14px;

  transition: 0.2s;

  background-image: url(${(props) => props.icon});
  background-repeat: no-repeat;
  background-size: cover;
`;

const NewMessageCircle = styled.div`
  width: 30px;
  min-width: 30px;
  height: 30px;

  border-radius: 15px;
  background: ${css.BRAND_YELLOW};

  transition: 0.2s;

  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    cursor: pointer;

    background: ${css.BRAND_GREEN};
  }

  &:hover ${NewMessageIcon} {
    background-image: url(${(props) => props.iconhover});
  }
`;

const UsernameBox = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const CheckmarkIcon = styled.div`
  padding-top: 6px;

  width: 18px;
  min-width: 18px;
  height: 18px;
`;

export default ({ data, page, limit, paginate, onNewMessageClick }) => {
  const { referrals, checkmarkData, numOfResults } = data.referralList;

  const list = referrals.map((referral) => {
    const profilePicture = referral.data.profile_picture
      ? AWS_PROFILE_IMAGES_URL + referral.data.profile_picture
      : profilePictureIcon;

    // preapare checkmark
    const referralCheckmarkData = checkmarkData.find(
      (data) => data.id === referral.referral_id
    );

    const checkmark = referralCheckmarkData?.checkmark;

    let planIcon = goldCheckmarkIcon;
    let checkmarkInfo = "Gold Ad Plan";

    switch (checkmark) {
      case 1:
        planIcon = bronzeCheckmarkIcon;
        checkmarkInfo = "Bronze Ad Plan";
        break;
      case 2:
        planIcon = silverCheckmarkIcon;
        checkmarkInfo = "Silver Ad Plan";
        break;
    }

    return (
      <tr key={referral.id}>
        <Cell>
          <AvatarNameBox>
            <AvatarIcon image={profilePicture}>
              {/* <img
                src={profilePicture}
                style={{ width: "100%", borderRadius: "50%" }}
              /> */}
            </AvatarIcon>
            <UsernameBox>
              <Name>{referral.data.username}</Name>
              {checkmark && (
                <CheckmarkIcon
                  data-tooltip-id="checkmark-info"
                  data-tooltip-html={checkmarkInfo}
                  data-tooltip-place="top"
                  data-tooltip-delay-show={250}
                  onClick={(e) => e.stopPropagation()}
                >
                  <img src={planIcon} style={{ width: "100%" }} />
                </CheckmarkIcon>
              )}
              <Tooltip id="checkmark-info" className="tooltip" />
            </UsernameBox>
          </AvatarNameBox>
        </Cell>
        <Cell>{dateFormatted(new Date(referral.created_at))}</Cell>
        <Cell>
          <Badge green={referral.qualified_at ? 1 : 0}>
            {referral.qualified_at ? "Yes" : "No"}
          </Badge>
        </Cell>
        <Cell>
          {referral.referral_reward && (
            <RewardBox>
              <CoinsIcon>
                <img src={coinsIcon} style={{ width: "100%" }} />
              </CoinsIcon>
              <Reward>{referral.referral_reward} Coins</Reward>
            </RewardBox>
          )}
          {!referral.referral_reward && <Reward>-</Reward>}
        </Cell>
        <Cell>
          <NewMessageCircle
            iconhover={messageWhiteIcon}
            onClick={() =>
              onNewMessageClick(
                referral.referral_id,
                referral.referral_shard_number
              )
            }
          >
            <NewMessageIcon icon={messageIcon} />
          </NewMessageCircle>
        </Cell>
      </tr>
    );
  });

  let showPagination = false;

  if (numOfResults > limit) showPagination = true;

  const maxPage = Math.ceil(numOfResults / limit);

  return (
    <ReferralListBox>
      <TableWrap className="table-wrap">
        {list.length > 0 && (
          <ListTable>
            <TableHead>
              <tr>
                <Label>Name</Label>
                <Label>Registered</Label>
                <Label>Qualified</Label>
                <Label>Reward</Label>
              </tr>
            </TableHead>
            <TableBody>{list}</TableBody>
          </ListTable>
        )}
        {list.length === 0 && (
          <NoResults>
            <NoResultsIcon>
              <img src={blockIcon} style={{ width: "100%" }} />
            </NoResultsIcon>
            <NoResultsText>You don't have any referrals yet.</NoResultsText>
          </NoResults>
        )}
      </TableWrap>
      {showPagination && (
        <Pagination>
          {page > 1 && (
            <ButtonRoundIcon
              icon={leftIcon}
              hoverIcon={leftWhiteIcon}
              background={css.BRAND_YELLOW}
              hoverBackground={css.BRAND_GREEN}
              iconSize="16px"
              buttonSize="32px"
              onClick={() => paginate("previous")}
            />
          )}
          {page < maxPage && (
            <ButtonRoundIcon
              icon={rightIcon}
              hoverIcon={rightWhiteIcon}
              background={css.BRAND_YELLOW}
              hoverBackground={css.BRAND_GREEN}
              iconSize="16px"
              buttonSize="32px"
              onClick={() => paginate("next")}
            />
          )}
        </Pagination>
      )}
    </ReferralListBox>
  );
};
